export const permissions = ['create', 'update', 'read', 'delete'];
export const adminRolePermissions = {
  caretaker: ['read'],
  users: ['create', 'read', 'update', 'delete'],
  roles: ['read'],
};
